export const categories = [
  {
    id: 1,
    name: "Shoes",
    namePl: "Buty",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
  },
  {
    id: 2,
    name: "Hoodies/Sweaters",
    namePl: "Bluzy/Swetry",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
  },
  {
    id: 3,
    name: "T-Shirts",
    namePl: "Koszulki",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-air-line",
  },
  {
    id: 4,
    name: "Jackets",
    namePl: "Kurtki",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-hail-line",
  },
  {
    id: 5,
    name: "Pants/Shorts",
    namePl: "Spodnie/Szorty",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
  },
  {
    id: 6,
    name: "Headwear",
    namePl: "Nakrycia głowy",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-cake-2-line",
  },
  {
    id: 7,
    name: "Sets",
    namePl: "Zestawy",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
  },
  {
    id: 8,
    name: "Underwear/Underpants",
    namePl: "Bielizna",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-shirt-line",
  },
  {
    id: 9,
    name: "Jersey",
    namePl: "Koszulki sportowe",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-football-line",
  },
  {
    id: 10,
    name: "Accessories",
    namePl: "Akcesoria",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
  },
  {
    id: 11,
    name: "Bags",
    namePl: "Torby",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-briefcase-line",
  },
  {
    id: 12,
    name: "Belts",
    namePl: "Paski",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
  },
  {
    id: 13,
    name: "Perfumes",
    namePl: "Perfumy",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
  },
  {
    id: 14,
    name: "Other Stuff",
    namePl: "Inne produkty",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
  },
];